import { all, put, select, takeLatest } from "redux-saga/effects";

import { BAZAAR_NAVIGATION_LOAD, BazaarNavigationLoadAction } from "@/mk2/apps/bazaar/actions";
import { ITEMS_PER_PAGE } from "@/mk2/apps/bazaar/constants";
import { bazaarGridLoad } from "@/mk2/apps/bazaar/containers/BazaarGrid/BazaarGrid.actions";
import { herBazaarLoad } from "@/mk2/apps/bazaar/containers/HerBazaar/HerBazaar.actions";
import { myBazaarLoad } from "@/mk2/apps/bazaar/containers/MyBazaar/MyBazaar.actions";
import { shoppingLoad } from "@/mk2/apps/bazaar/containers/Shopping/Shopping.actions";
import { wishlistLoad } from "@/mk2/apps/bazaar/containers/Wishlist/Wishlist.actions";
import { wishlistInactiveLoad } from "@/mk2/apps/bazaar/containers/WishlistInactive/WishlistInactive.actions";
import { watchdogKey } from "@/mk2/apps/bazaar/helpers/filter";
import { NavigationType, PerFilterState } from "@/mk2/apps/bazaar/reducers/navigation";
import { getBazaarNavigationState } from "@/mk2/apps/bazaar/selectors/navigation";
import { bazaarGridUrl } from "@/mk2/apps/bazaar/urls";
import { dict } from "@/mk/bazaar/product/categories";
import { serializeFilterForPathname } from "@/mk/bazaar/product/filter/filterUtils";

const SCAN_RANGE = [1, 2, 3];

export function* load({ currentId }: BazaarNavigationLoadAction) {
    const state: PerFilterState = yield select(getBazaarNavigationState);

    // No paging information - ignore
    if (state.type === null) {
        return;
    }

    const found = Object.keys(state.ids).find((key) => state.ids[key] === currentId);
    // Unknown product - ignore
    if (found === undefined) {
        return;
    }

    const index = parseInt(found, 10);

    let start: number | null = null;
    for (const scan of SCAN_RANGE) {
        if (index - scan > 0 && !state.ids[index - scan]) {
            start = Math.max(index - scan + 1 - ITEMS_PER_PAGE, 0);
            break;
        } else if (index + scan < state.hits && !state.ids[index + scan]) {
            start = index + scan;
            break;
        }
    }

    if (start === null) {
        // Nothing to load
        return;
    }

    if (state.type === NavigationType.MY_BAZAAR) {
        yield put(
            myBazaarLoad(state.filter.users[0], {
                ...state.filter,
                start,
            }),
        );
    } else if (state.type === NavigationType.HER_BAZAAR) {
        yield put(
            herBazaarLoad(state.filter.users[0], {
                ...state.filter,
                start,
            }),
        );
    } else if (state.type === NavigationType.BAZAAR) {
        const cat = state.filter.cats.length ? dict()[state.filter.cats[0]] : null;
        yield put(
            bazaarGridLoad(
                {
                    ...state.filter,
                    start,
                },
                watchdogKey(state.filter, bazaarGridUrl, {
                    category: cat && cat.slug,
                    filters: serializeFilterForPathname(state.filter),
                }),
            ),
        );
    } else if (state.type === NavigationType.WISHLIST) {
        yield put(
            wishlistLoad({
                ...state.filter,
                start,
            }),
        );
    } else if (state.type === NavigationType.WISHLIST_INACTIVE) {
        yield put(wishlistInactiveLoad(start));
    } else if (state.type === NavigationType.SHOPPING) {
        yield put(
            shoppingLoad(
                state.shoppingFilter.username,
                state.shoppingFilter.filter,
                state.shoppingFilter.sort,
                start ? Math.ceil((start + 1) / ITEMS_PER_PAGE) : 1,
            ),
        );
    }
}

export default function* root() {
    yield all([takeLatest(BAZAAR_NAVIGATION_LOAD, load)]);
}
